import { AuthActionTypes } from 'src/store/auth/types';
import { SharedActionTypes } from 'src/store/shared/types';
import { RoleRights } from 'src/store/user/types';
import { action } from 'typesafe-actions';
import { history, store } from './../index';
import { CardImage } from './../store/shared/types';
import { removeAxiosToken, setAxiosToken } from './axiosHelper';
import { eraseCookie, getCookie, setCookie } from './cookie';

export const checkAuth = (dispatch: any) => {
  const token = getToken();
  const user = getUser();
  console.log(user);
  if (token == null || user == null) {
    if (location.pathname !== "/impressum") {
      history.push('/login');
    }
  } else {
    setAxiosToken(token);
    dispatch(action(AuthActionTypes.SET_USER, user));
  }
};

export const hasToken = (): boolean => {
  return getCookie('token') != null;
};

export const getToken = (): string | null => {
  return getCookie('token');
};

export const setToken = (token: string) => {
  setCookie('token', token, 2);
};

export const setUser = (user: any) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const setUserImage = (image: CardImage | undefined) => {
  const user = getUser();
  user.image = image;
  setUser(user);
};

export const getUser = () => {
  const jsonString = localStorage.getItem('user');
  if (jsonString) {
    return JSON.parse(jsonString);
  }
};

export const userCan = (right: RoleRights): boolean => {
  const user = getUser();
  if (!user || !user.role) {
    return false;
  }
  if (user.role[RoleRights[right]]) {
    return true;
  } else {
    return false;
  }
};

export const logout = () => {
  store.dispatch(action(SharedActionTypes.RESET));
  removeAxiosToken();
  eraseCookie('token');
  localStorage.removeItem('user');
};



// WEBPACK FOOTER //
// ./src/utils/authHelper.ts